import React from 'react';
import { Provider } from 'react-redux';

import logo from './logo.svg';
import './styles/tailwind.css';
import store from './store';
import Home from './pages/Home';

function App() {
  return (
    <div>
      <Provider store={store}>
        <Home/>
      </Provider>
    </div>
  );
}

export default App;
